import Icon from './Icons';

type Alert = {
  appearance: string;
  content: string;
  isDismissable?: boolean;
  onClose?: () => void;
  dismissAriaLabel?: string;
  testID?: string;
};

type AlertAppearance = {
  icon: 'check-circle' | 'alert-circle' | 'info';
  iconClass: string;
  alertBackground: string;
};

function getAlertProps(type: string): AlertAppearance {
  if (type === 'success') {
    return { icon: 'check-circle', iconClass: 'fill-success-70', alertBackground: 'bg-success-10' };
  }
  if (type === 'danger') {
    return { icon: 'alert-circle', iconClass: 'fill-danger-70', alertBackground: 'bg-danger-20' };
  }
  return { icon: 'info', iconClass: 'fill-interactive-70', alertBackground: 'bg-brand-20' };
}

export default function Alert({ appearance, content, isDismissable, onClose, dismissAriaLabel, testID }: Alert) {
  const { icon, iconClass, alertBackground } = getAlertProps(appearance);
  return (
    <div className={`flex w-full justify-between rounded-xl p-4 shadow-4 ${alertBackground}`} data-cvent-id={testID}>
      <div className="flex flex-row items-center gap-3">
        <Icon id={icon} className={`h-6 w-6 shrink-0 ${iconClass}`} />
        <div
          className="font-primary text-b-md font-normal"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
      {isDismissable ? (
        <button type="button" data-cvent-id={`${testID}-close`} aria-label={dismissAriaLabel} onClick={onClose}>
          <span>
            <Icon id="x" className="h-6 w-6 shrink-0" />
          </span>
        </button>
      ) : null}
    </div>
  );
}
